
import { renderSwitch } from "./RenderSwitch";

const SectionCardBody = (props: any) => {
  return <>{renderSwitch(props)}</>;
};

export default SectionCardBody;
